<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Forbidden</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_iv"></a><a id="copy"></a><span class="small">THE FORBIDDEN</span>. Copyright © 2005 by Leslie Esdaile Banks. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="linespace"> </p>
<p class="para"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="linespace"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="linespace"> </p>
<p class="para">Banks, L.A.</p>
<p class="indent-para">The forbidden : a vampire huntress legend / L. A. Banks.— 1st ed.</p>
<p class="indent-para">     p. cm.</p>
<p class="indent-para">ISBN 0-312-33622-5</p>
<p class="indent-para">EAN 978-0-312-33622-6</p>
<p class="indent-para">  1. Richards, Damali (Fictitious character)—Fiction. 2. African American women—Fiction. 3. Women martial artists—Fiction. 4. Vampires—Fiction. 5. Occult fiction, gsafd I. Title.</p>
<p class="linespace"> </p>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td valign="top"><p class="para">PS3602.A64F67 2005</p></td>
<td valign="top"><p class="para"> </p></td>
</tr>
<tr>
<td valign="top"><p class="para">813’.6—dc22</p></td>
<td valign="top"><p class="right-para">2004065825</p></td>
</tr>
</tbody></table>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para">10 9 8 7 6 5 4 3</p>
<p class="linespace"> </p>
<p class="linespace"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?5f2f3321